module.exports = __webpack_public_path__ + "static/media/3cardpuresequence.ee5980bd.png";